import { render, staticRenderFns } from "./InstallationBoard.vue?vue&type=template&id=87ea56da"
import script from "./InstallationBoard.vue?vue&type=script&lang=js"
export * from "./InstallationBoard.vue?vue&type=script&lang=js"
import style0 from "./InstallationBoard.vue?vue&type=style&index=0&id=87ea56da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports